<p-blockui [blocked]="isLoading">
  <p-progress-spinner></p-progress-spinner>
</p-blockui>

<div class="flex w-full justify-center">
  <p-stepper [value]="activeStep" class="basis-[100vw] pb-20" [linear]="true">
    <p-step-list>
      <p-step [value]="1">Datos básicos</p-step>
      <p-step [value]="2">Completado</p-step>
    </p-step-list>

    <p-step-panels>      
      <p-step-panel [value]="1">
        <ng-template #content let-activateCallback="activateCallback">
          <h1 class="mt-4 text-3xl font-semibold">Completa el formulario</h1>
          <div
            class="flex flex-col mt-4 border border-solid border-gray-200 bg-white rounded-lg p-6"
          >
            <div class="grid grid-cols-[1fr_3fr] gap-10">
              <div class="col-span-1 flex flex-col">
                <span class="text-black font-bold">Información general</span>
                <span class="mt-1 text-sm text-gray-600">Formulario de información básica acerca de la empresa</span>
              </div>

              <form [formGroup]="form" class="flex max-w-lg flex-col gap-5">
                <div class="flex flex-col gap-2">
                  <label for="logo" class="text-black font-semibold">Logo*</label>
                  <div class="card">
                    <p-fileupload
                      id="logo"
                      accept="image/*"
                      maxFileSize="1048576"
                      chooseLabel="Seleccionar"
                      (onSelect)="onSelectFile($event)"
                      invalidFileSizeMessageSummary="El peso máximo es de 1MB"
                      invalidFileTypeMessageSummary="Solo se aceptan archivos tipo PNG y JPG"
                      [showUploadButton]="false"
                      [showCancelButton]="false"
                    >
                      <ng-template #empty>
                        @if (!fileUrl) {
                          <div class="flex flex-col items-center gap-4 w-full pb-8">
                            <span class="material-symbols-outlined text-black add-photo-icon">
                              add_photo_alternate
                            </span>
                            <span class="font-bold w-60 text-center text-black">
                              Arrasta tus archivos aquí o da clic en el botón seleccionar
                            </span>
                          </div>
                        }
                      </ng-template>
                      <ng-template pTemplate="content" let-files>
                        @if (fileUrl) {
                          <div class="flex flex-row justify-between items-center w-full h-30">
                            <div class="flex content-center items-center">
                              <img 
                                [src]="fileUrl"
                                alt="logo"
                                class="text-xs w-20 h-20"/>

                              <span class="pl-4 truncate">
                                {{ fileName }}
                              </span>
                            </div>
              
                            <p-button
                              variant="text"
                              severity="danger"
                              icon="pi pi-times" 
                              class="custom-button"
                              (onClick)="removeLogo()">
                            </p-button>
                          </div>
                        }
                      </ng-template>
                    </p-fileupload>
                  </div>
                  <p-message severity="error" size="small" variant="simple">
                    {{ getErrorMessage('logo') }}
                  </p-message>
                </div>

                <div class="flex flex-col gap-2">
                  <label for="name" class="text-black font-semibold">Nombre*</label>
                  <input
                    pInputText
                    fluid
                    id="name"
                    formControlName="name"
                    placeholder="Ingrese el nombre del grupo empresarial"
                    [invalid]="isInvalid('name')"
                  />
                  <p-message severity="error" size="small" variant="simple">
                    {{ getErrorMessage('name') }}
                  </p-message>
                </div>

                <div class="flex flex-col gap-2">
                  <label for="description" class="text-black font-semibold">Descripción*</label>
                  <textarea
                    pTextarea
                    fluid
                    rows="5"
                    cols="30"
                    id="description"
                    formControlName="description"
                    placeholder="Ingrese una descripción"
                    [invalid]="isInvalid('description')"
                  ></textarea>
                  <p-message severity="error" size="small" variant="simple">
                    {{ getErrorMessage('description') }}
                  </p-message>
                </div>

                <div class="flex flex-col gap-2">
                  <label for="contactName" class="text-black font-semibold">Nombre contacto principal*</label>
                  <input
                    pInputText
                    fluid
                    id="contactName"
                    formControlName="contactName"
                    placeholder="Ingrese el nombre del contacto"
                    [invalid]="isInvalid('contactName')"
                  />
                  <p-message severity="error" size="small" variant="simple">
                    {{ getErrorMessage('contactName') }}
                  </p-message>
                </div>

                <div class="flex flex-col gap-2">
                  <label for="contactPhone" class="text-black font-semibold">Teléfono contacto principal*</label>
                  <input
                    pInputText
                    fluid
                    id="contactPhone"
                    formControlName="contactPhone"
                    placeholder="Ingrese el teléfono del contacto"
                    [invalid]="isInvalid('contactPhone')"
                  />
                  <p-message severity="error" size="small" variant="simple">
                    {{ getErrorMessage('contactPhone') }}
                  </p-message>
                </div>

                <div class="flex flex-col gap-2">
                  <label for="contactEmail" class="text-black font-semibold">Correo contacto principal*</label>
                  <input
                    pInputText
                    fluid
                    id="contactEmail"
                    formControlName="contactEmail"
                    placeholder="Ingrese el correo del contacto"
                    [invalid]="isInvalid('contactEmail')"
                  />
                  <p-message severity="error" size="small" variant="simple">
                    {{ getErrorMessage('contactEmail') }}
                  </p-message>
                </div>

                <div class="flex flex-col gap-2">
                  <label for="maxUsers" class="text-black font-semibold">Usuarios máximos*</label>
                  <p-inputnumber
                    fluid
                    id="maxUsers"
                    formControlName="maxUsers"
                    [useGrouping]="false"
                    placeholder="Selecciona la cantidad de usuarios que podrá tener esta empresa"
                    [invalid]="isInvalid('maxUsers')"
                  />
                  <p-message severity="error" size="small" variant="simple">
                    {{ getErrorMessage('maxUsers') }}
                  </p-message>
                </div>
              </form>
            </div>
          </div>
        </ng-template>
      </p-step-panel>

      <p-step-panel [value]="2">
        <ng-template #content let-activateCallback="activateCallback"></ng-template>
      </p-step-panel>
    </p-step-panels>
  </p-stepper>

  <app-form-footer>
    <div class="flex flex-row justify-end gap-2 w-full">
      <p-button
        fluid
        label="Cancelar"
        variant="text"
        severity="primary"
        (onClick)="onClickCancel()"
        class="w-30"
      ></p-button>

      <p-button
        fluid
        label="Regresar"
        (onClick)="onClickPreviousStep()"
        severity="secondary"
        [disabled]="isFirstStep()"
        class="w-30"
      ></p-button>

      <p-button
        fluid
        label="Siguiente"
        (onClick)="onClickNextStep()"
        [disabled]="isLastStep()"
        class="w-30"
      ></p-button>
    </div>
  </app-form-footer>
</div>

<app-dialog
  [(visible)]="visibleSuccessDialog"
  type="success"
  [title]="dialogTitle"
  [message]="dialogMessage"
  buttonText="Confirmar"
  (onButtonClick)="onCloseDialog()">
</app-dialog>

<p-toast></p-toast>